let loaded = false;
let fullyLoaded = false;

function pageLoaded() {
  if (!loaded) {
    loaded = true;
    document.body.classList.add('loaded');
  }
}

// LOADER
// FULLY LOADED
window.addEventListener('load', function () {
  pageLoaded();
  fullyLoaded = true;

});
// TIMEOUT
setTimeout(() => {
  pageLoaded()
}, 3000);
// =========



// FRAME BY FRAME
const html = document.documentElement,
  // frameHolder = document.getElementById("animFrame"),
  frameCount = 38,
  framePath = `./img/ani_v2/`;

const currentFrame = index => (
  `${framePath}ani01_${index.toString().padStart(2, '0')}.webp`
);
const preloadImages = () => {
  for (let i = 1; i <= frameCount; i++) {
    const img = new Image();
    img.src = currentFrame(i);
    // console.log(currentFrame(i));
  }
};
if (window.matchMedia('(min-width: 768px)').matches) {
  preloadImages();
}



// ================







// let's get this party started
document.addEventListener('DOMContentLoaded', function () {

  console.log('domcontent');

  // JUST IN CASE
  setTimeout(() => {
    pageLoaded();
  }, 2000);


  const ani01 = document.getElementById('ani01');
  if (window.matchMedia('(min-width: 768px)').matches && ani01) {


    ani01.innerHTML = '';

    for (let i = 1; i <= frameCount; i++) {

      let aniPic = document.createElement('img');
      aniPic.src = currentFrame(i);
      aniPic.classList.add('s-hero__ill-ani');
      if (i == 1) {
        aniPic.classList.add('m-active');
      }
      aniPic.width = 600;
      aniPic.height = 600;
      aniPic.alt = '';
      ani01.appendChild(aniPic);

    }

    const aniDura = 42,
      aniDela = 3000;


    let aniNum = 0;
    function nextFrame() {
      aniNum++;
      ani01.querySelector('img.m-active').classList.remove('m-active');
      ani01.querySelector(`img:nth-child(${aniNum})`).classList.add('m-active');
      if (aniNum < frameCount) {
        setTimeout(() => {
          nextFrame()
        }, aniDura);
      }
      else {
        setTimeout(() => {
          prevFrame()
        }, aniDela);
      }
    }
    function prevFrame() {
      aniNum--;
      ani01.querySelector('img.m-active').classList.remove('m-active');
      ani01.querySelector(`img:nth-child(${aniNum})`).classList.add('m-active');
      if (aniNum > 1) {
        setTimeout(() => {
          prevFrame()
        }, aniDura);
      }
      else {
        setTimeout(() => {
          nextFrame()
        }, aniDela);
      }
    }

    const aniWait = setInterval(function () {
      if (fullyLoaded) {
        clearInterval(aniWait);
        setTimeout(() => {
          nextFrame();
        }, 1500);
      }
    }, 500);


  }
});


// =================================================
// =================================================
// =================================================

